import React from 'react';

const tile = 'w-10 h-10 rounded-md overflow-hidden shrink-0 flex items-center justify-center';

const RingsSvg: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 72" className="w-8 h-8" fill="none" aria-hidden="true">
    <circle cx="24" cy="26" r="8" stroke="currentColor" strokeWidth="6.5" />
    <circle cx="56" cy="26" r="8" stroke="currentColor" strokeWidth="6.5" />
    <path d="M18 50 C 30 64 50 64 62 50" stroke="currentColor" strokeWidth="6.5" strokeLinecap="round" />
  </svg>
);

export const OurwareMark: React.FC<{ variant?: "tile" | "footer" }> = ({
  variant = "tile",
}) => {
  if (variant === "footer") {
    return (
      <span
        className="inline-flex w-7 h-7 text-current shrink-0"
        data-testid="mark-ourware"
      >
        <RingsSvg />
      </span>
    );
  }
  return (
    <div className={`${tile} bg-gray-900 border border-blue-500/40 text-blue-200`} data-testid="mark-ourware">
      <RingsSvg />
    </div>
  );
};

/** Same Ourware rings mark, teal — locked sister tile for scool.ing. */
export const ScoolingMark: React.FC = () => (
  <div className={`${tile} bg-black border border-teal-500/50 text-teal-400`} data-testid="mark-scooling">
    <RingsSvg />
  </div>
);

/** MuseHub three-node mark from the product screenshot — locked. */
export const MuseHubMark: React.FC = () => (
  <div className={`${tile} bg-[#111111]`} data-testid="mark-musehub">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className="w-full h-full" aria-hidden="true">
      <rect width="64" height="64" fill="#111111" />
      <g fill="#7EB6E8" stroke="#7EB6E8" strokeWidth="5" strokeLinecap="round">
        <line x1="32" y1="20" x2="16" y2="46" />
        <line x1="32" y1="20" x2="48" y2="46" />
        <circle cx="32" cy="18" r="6.5" stroke="none" />
        <circle cx="14" cy="48" r="6.5" stroke="none" />
        <circle cx="50" cy="48" r="6.5" stroke="none" />
      </g>
    </svg>
  </div>
);

/** Knowtation: black tile, white K filling the vertical space — locked. */
export const KnowtationMark: React.FC = () => (
  <div className={`${tile} bg-black`} data-testid="mark-knowtation">
    <span
      className="text-white font-black leading-none select-none"
      style={{ fontSize: '2.9rem', lineHeight: 0.82 }}
      aria-hidden="true"
    >
      K
    </span>
  </div>
);
